import { render, staticRenderFns } from "./container_inquiry.vue?vue&type=template&id=226a96f1&scoped=true&"
import script from "./container_inquiry.vue?vue&type=script&lang=js&"
export * from "./container_inquiry.vue?vue&type=script&lang=js&"
import style0 from "./container_inquiry.vue?vue&type=style&index=0&id=226a96f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a96f1",
  null
  
)

export default component.exports